import { gql } from '@apollo/client';
import { Dispatch } from '../components/architecture/frontend/index'
import { merge } from 'rxjs'
import { map, filter, withLatestFrom } from 'rxjs/operators'

import _ from 'lodash'

import bufferObject from './bufferObject'

bufferObject('shipmentTypes')

const fragment = `
  fragment SampleData on SampleType {
    id
    name   
    code
    isActive
  }
  `


const GET_SAMPLE_TYPES = gql`
  query sampleTypes {
    sampleTypes {
      ...SampleData
    }
  }
  ${fragment},
`;

const MUTATE_UPSERT_SAMPLE_TYPES = gql`
  mutation upsertShipmentTypes(
      $shipmentTypes: [ShipmentTypeInput]
    ){
      upsertShipmentTypes(
        shipmentTypes: $shipmentTypes
      ) {
        ...SampleData
      }
    }
    ${fragment}
`;

Dispatch.getState('user.email')
  .pipe(
  )
  .subscribe(e => {
    if (_.isNil(e)) {
      Dispatch.nextAction('__.buffer.setRaw.shipmentTypes', null)
    }
    else {
      Dispatch.nextAction('__.buffer.setLoading.shipmentTypes')
      Dispatch.nextAction('Request.shipmentTypes', { type: 'query', query: GET_SAMPLE_TYPES, variables: { }, poll: process.env.REACT_APP_POLL_INTERVAL,  retry: process.env.REACT_APP_RETRY_INTERVAL })
    }
  })

  merge(Dispatch.getAction('Response.shipmentTypes'), Dispatch.getAction('Response.shipmentTypes.save'))
  .pipe(
    filter(e => _.isNil(e.errors)),
    map(e => e.data.sampleTypes ?? e.data.upsertShipmentTypes)
  )
  .subscribe(e => Dispatch.nextAction('__.buffer.setRawAndClearBuffer.shipmentTypes', e))

Dispatch.getAction('shipmentTypes.save')
    .pipe(
      withLatestFrom(Dispatch.getState('shipmentTypes.bufferData')),
      map(([details, buffer]) => buffer.map(data => ({
        id: data.id, 
        code: data.code, 
        name: data.name, 
        type: details.type, 
        attention: data.attention, 
        phone: data.phone, 
        email: data.email, 
        emailCC: data.emailCC,
        address: data.address,
        city: data.city,
        state: data.state,
        zip: data.zip, 
      })))
    )
    .subscribe(e => Dispatch.nextAction('Request.shipmentTypes.save', { type: 'mutation', query: MUTATE_UPSERT_SAMPLE_TYPES, variables: { shipmentTypes: e } }))